import { Dispatch, SetStateAction } from 'react'
import { Dialog, DialogContent } from '@mui/material'

import VideoPlayer from '../VideoPlayer/VideoPlayer';

import '../../Shared/css/MisRutinas/modalCalentamiento.css';


interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  url: string;
};

const ModalCalentamiento = ({ isOpen, setIsOpen, url }: Props) => {

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          maxWidth: '480px',
          width: '100%',
          margin: '16px',
          boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
          overflow: 'hidden',
        }
      }}
    >
      {/* Custom Header */}
      <div className="mcal-header">
        <button className="mcal-back-btn" onClick={() => setIsOpen(false)}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="mcal-header-text">
          <span className="mcal-label">Antes de empezar</span>
          <h2 className="mcal-title">Calentamiento</h2>
        </div>
        <button className="mcal-close-btn" onClick={() => setIsOpen(false)}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <DialogContent sx={{ padding: 0 }}>
        {/* Video */}
        <div className="mcal-video-wrapper">
          <VideoPlayer url={url} />
        </div>

        {/* Tip */}
        <div className="mcal-tip">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z"/><path d="M12 16v-4"/><path d="M12 8h.01"/>
          </svg>
          <p>Realiza este calentamiento antes de cada sesión para preparar tu cuerpo y prevenir lesiones.</p>
        </div>

        {/* Close Button */}
        <div className="mcal-actions">
          <button className="mcal-done-btn" onClick={() => setIsOpen(false)}>
            Entendido
          </button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ModalCalentamiento;
